import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

export default function ContextHelpButton({ label = 'Ajuda desta tela', onClick, className }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        'inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-500 shadow-sm transition hover:border-indigo-200 hover:bg-indigo-50 hover:text-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2',
        className
      )}
      aria-label={label}
      title={label}
    >
      <QuestionMarkCircleIcon className="h-5 w-5" aria-hidden="true" />
    </button>
  );
}
